import { createContext } from "react";
import type { V2Value } from "@/features/applications/api/applications.api";

export const ValidationContext = createContext<{
  missing: Set<string>;

  errors: Map<string, string>;
  markFilled: (key: string) => void;

  markMissing: (key: string) => void;
  markError: (key: string, message: string) => void;

  prefix: string;
}>({
  missing: new Set(),
  errors: new Map(),
  markFilled: () => {},
  markMissing: () => {},
  markError: () => {},
  prefix: "",
});

export const isEmptyVal = (v: V2Value): boolean =>
  v == null || v === "" || (Array.isArray(v) && v.length === 0);

export const overMaxLength = (maxLength: number | undefined, v: V2Value): boolean => {
  if (maxLength == null) return false;
  const s = typeof v === "string" ? v : Array.isArray(v) ? v.join(", ") : "";
  return s.length > maxLength;
};
